import React from "react";
import './carrusel_pillars.css';

// Importación de SVGs / Imágenes
import ejeEstrategico from "../../assets/pillars/ejeEstrategico.jpg";
import desarrolloDeTalento from "../../assets/pillars/desarrolloDeTalento.jpg";
import formacionLiderazgo from "../../assets/pillars/formacionLiderazgo.jpg";
import gestionDeCambio from "../../assets/pillars/gestionDeCambio.jpg";
import vehiculoYFacilitador from "../../assets/pillars/vehiculoYFacilitador.jpg";

const Carrusel_Pillars = () => {
  const cards = [
    { icon: ejeEstrategico, title: "Eje Estratégico<br/>de toda<br/>organización" },
    { icon: desarrolloDeTalento, title: "Clave en el<br/>Desarrollo de<br/>Talento" },
    { icon: formacionLiderazgo, title: "Crítico en la<br/>Formación de<br/>Liderazgo" },
    { icon: gestionDeCambio, title: "Pilar de la Gestión<br/>del Cambio" },
    { icon: vehiculoYFacilitador, title: "Vehículo y<br/>Facilitador de la<br/>Cultura" },
  ];

  return (
    <section className="cards-wrapper">
      <div className="cards-container">
        {cards.map((card, index) => (
          <article className="hover-card" key={index}>
            <div className="card-image-container">
              <img src={card.icon} alt="Pilar" />
            </div>
            <h2 dangerouslySetInnerHTML={{ __html: card.title }} />
          </article>
        ))}
      </div>
    </section>
  );
}

export default Carrusel_Pillars;